<template>
  <form :class="{ 'pl-chat-setting--open': open }" class="pl-chat-setting">
    <div class="pl-chat-setting__title">
      <h3 class="pl-chat-setting__title-text">Настройка чата</h3>
      <p class="pl-chat-setting__title-description" />
    </div>

    <div class="pl-chat-setting__description">
      <h4 v-if="userIsChatCreator" class="pl-chat-setting__description-subtitle">Введите название чата</h4>

      <v-text-field
        v-model="name"
        :value="chatName"
        :rules="rules"
        :disabled="!userIsChatCreator"
        label="Название чата"
        hint="Название публичного чата обязательно для заполнения"
        clearable
        required
        @input="setName()"
        @change="setName()"
      />

      <!--      ВЫБОР ТИПА ЧАТА ПОКА НЕ РЕАЛИЗОВАН-->
      <!--      <v-container fluid>-->
      <!--        <p>Тип чата:</p>-->

      <!--        <v-radio-group-->
      <!--          v-model="type"-->
      <!--          :mandatory="true"-->
      <!--        >-->
      <!--          <v-radio-->
      <!--            label="приватный"-->
      <!--            value="private"-->
      <!--            color="primary"-->
      <!--          />-->
      <!--          <v-radio-->
      <!--            label="публичный"-->
      <!--            value="public"-->
      <!--            color="primary"-->
      <!--          />-->
      <!--        </v-radio-group>-->
      <!--      </v-container>-->

      <!--      <v-switch-->
      <!--        v-model="chatTypePrivate"-->
      <!--        :label="labelChatType"-->
      <!--      />-->

      <div v-if="userIsChatCreator" class="pl-chat-setting__image-box">
        <label>
          <input id="chatLogo" ref="chatLogo" type="file" @input="setChatPicture" />

          <div>Добавить изображение чата</div>
        </label>
      </div>
    </div>

    <div class="pl-chat-setting__users">
      <div class="pl-chat-setting__users-list">
        <pl-chat-user-list :members="users" @add-member="addMember" />
      </div>

      <div class="pl-chat-setting__members-list">
        <pl-chat-members-list :members="chatMembers" @remove-member="removeMember" />
      </div>
    </div>
    <div class="pl-chat-setting__action">
      <v-btn @click="closeNotSave()"> Выйти без сохранения </v-btn>

      <v-btn :disabled="disabledButtonSave() || !name.length" color="primary" @click="saveChatData()">
        Сохранить и закрыть
      </v-btn>
    </div>
  </form>
</template>

<script>
import Form from '../Form/Form'
import PlChatUserList from './PlChatUserList'
import PlChatAvatar from './PlChatAvatar'
import PlChatMembersList from './PlChatMembersList'

export default {
  name: 'PlChatSetting',
  components: {
    PlChatMembersList,
    PlChatAvatar,
    PlChatUserList,
    Form,
  },
  data() {
    return {
      type: '',
      name: '',
      members: [],
      membersIds: [],
      rules: [
        value => !!value || 'Название публичного чата обязательно для заполнения',
        value => (value && value.length >= 3) || 'Минимальная длина названия 3 символа',
      ],
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    activeChatId: {
      type: Number || null,
      default: null,
    },
  },
  computed: {
    activeChat() {
      return this.$store.state.plChat.chatList.find(chat => chat.id === this.activeChatId)
    },
    userIsChatCreator() {
      return this.$store.state.plChat.profile.id === this.activeChat.authorId || this.activeChat.id === -1
    },
    users() {
      return this.$store.state.plChat.users.length
        ? this.$store.state.plChat.users.filter(user => this.chatMembers.every(member => member.id !== user.id))
        : []
    },
    chatMembers() {
      this.members = this.activeChatId ? this.activeChat.users : []

      return this.members
    },
    chatName() {
      const chatName = this.$store.state.plChat.chatList.find(chat => chat.id === this.activeChatId)
      this.name = chatName ? chatName.name : this.name

      return this.name
    },
  },
  methods: {
    setChatPicture() {
      const fileInput = document.getElementById('chatLogo')

      this.$store.commit('setChatIcon', {
        value: fileInput.files[0],
        chatId: this.activeChatId,
      })
    },
    closeNotSave() {
      this.$emit('close-setting-not-save')
    },
    async saveChatData() {
      let idNewChat

      if (this.activeChatId === -1) {
        idNewChat = await this.$store.dispatch('createChat', this.activeChatId)
        this.$emit('closed-setting', idNewChat)
        this.$store.commit('removeChat', this.activeChatId)
      } else {
        idNewChat = await this.$store.dispatch('saveChat', this.activeChatId)
        this.$emit('closed-setting', idNewChat)
      }
    },
    //todo ok
    async addMember(user) {
      if (this.activeChatId !== -1) {
        const result = await this.$store.dispatch('addMemberToChat', {
          chatId: this.activeChatId,
          userId: user.id,
        })

        if (result === 'success') {
          this.members = this.$store.commit('addMembersToChat', {
            userId: user.id,
            chatId: this.activeChatId,
            chatType: 'public',
          })
          this.$notify({
            group: 'hasBottomNavigation',
            title: 'Добавление собеседника в чат',
            type: 'success',
            text: `Вы успешно добавили пользователя ${user.name}`,
          })
        } else if (result === 'failed') {
          this.$notify({
            group: 'hasBottomNavigation',
            title: 'Не удалось добавить собеседника в чат',
            type: 'error',
            text: 'Попобуйте еще раз позже',
          })
        }
      } else {
        this.members = this.$store.commit('addMembersToChat', {
          userId: user.id,
          chatId: this.activeChatId,
          chatType: 'public',
        })
      }
    },
    //todo ok
    async removeMember(user) {
      if (this.activeChatId !== -1) {
        try {
          await this.$store.dispatch('removeMemberToChat', {
            chatId: this.activeChatId,
            userId: user.id,
          })

          this.members = this.$store.commit('removeMembersToChat', {
            userId: user.id,
            chatId: this.activeChatId,
          })
          this.$notify({
            group: 'hasBottomNavigation',
            title: 'Удаление собеседника из чата',
            type: 'success',
            text: `Вы успешно удалили пользователя ${user.name}`,
          })
        } catch {
          this.$notify({
            group: 'hasBottomNavigation',
            title: 'Не удалось удалить собеседника из чата',
            type: 'error',
            text: 'Попобуйте еще раз позже',
          })
        }
      } else {
        this.members = this.$store.commit('removeMembersToChat', {
          userId: user.id,
          chatId: this.activeChatId,
        })
      }
    },
    // todo ok
    setName() {
      this.$store.commit('setChatName', {
        value: this.name,
        chatId: this.activeChatId,
      })
    },
    disabledButtonSave() {
      let value = false

      if (this.chatMembers) {
        value = this.chatMembers.length <= 1
      }

      return value
    },
  },
}
</script>

<style scoped lang="scss">
.pl-chat-setting {
  background-color: white;

  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: 4rem auto calc(48px + 2rem);
  height: calc(85vh - 48px - 1rem);

  position: absolute;
  z-index: 1;
  bottom: 100%;
  right: 0;
  left: 0;
  transition: bottom 0.6s ease-in-out;
  overflow: hidden;

  &--open {
    bottom: 0;
  }

  &__title {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
    display: flex;
    align-items: center;
    padding: 1rem 2rem;
    background-color: rgba(0, 0, 0, 0.04);
  }
  &__title-description {
    margin: 0 1rem;
  }

  &__description {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 2;
    grid-row-end: 3;
    margin: 1rem 0;
    padding: 0 1rem 0 2rem;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }

  &__users {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 2;
    grid-row-end: 3;

    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }

  &__users-list {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    padding-right: 1rem;
  }

  &__members-list {
    grid-column-start: 2;
    grid-column-end: 3;
    grid-row-start: 1;
    grid-row-end: 2;
  }

  &__action {
    grid-column-start: 1;
    grid-column-end: 3;
    grid-row-start: 3;
    grid-row-end: 4;
    display: flex;
    justify-content: flex-end;
    padding: 1rem;
  }

  &__image-box {
    margin: 2rem 0;

    label {
      input {
        display: none;
      }

      div {
        background-color: #f5f5f5;
        padding: 0 16px;
        align-items: center;
        border-radius: 2px;
        display: inline-flex;
        height: 36px;
        flex: 0 0 auto;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        justify-content: center;
        margin: 6px 0;
        min-width: 88px;
        outline: 0;
        text-transform: uppercase;
        text-decoration: none;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
        position: relative;
        vertical-align: middle;
        user-select: none;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
          0px 1px 5px 0px rgba(0, 0, 0, 0.12);
      }
    }
  }

  &__image {
    width: 10rem;
    height: 10rem;
    margin: 1rem;
    border-radius: 50%;
    overflow: hidden;

    & img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
